export default __webpack_public_path__ + "static/media/935.33bb8ebc.png";